export const MON_USER_PERMISSIONS = {
    policies: 'policies',
    qa: 'qa',
    accessibility: 'accessibility',
    seo: 'seo',
    uptime: 'uptime',
    inventory: 'inventory',
    statistics: 'statistics',
    content_pages: 'content_pages',
    pagecorrect: 'pagecorrect',
    performance: 'performance',
    data_privacy: 'dataprivacy',
    cookie_banner: 'cookie_banner',
    page_fix: 'page_fix',
} as const;

export type UserPermissionKey = keyof typeof MON_USER_PERMISSIONS;

export type UserPermission = {
    key: UserPermissionKey;
    label: string;
};
